import {
  NavItemExternalLink,
  NavItemInternalLink,
} from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { SubMenuType } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/types';
import { buildLink } from '@/utils';
import { useTranslation } from 'react-i18next';

export function useMitarbeiterSubmenuItems({
  handleClose,
  setActiveSubmenu,
}: {
  handleClose(): void;
  setActiveSubmenu: (type: SubMenuType) => void;
}) {
  const { t } = useTranslation();
  const menuItems = [];

  menuItems.push(
    <NavItemExternalLink href={buildLink('mitarbeiterListe')}>
      {t('domain.navigation.menuItems.mitarbeiter.uebersicht')}
    </NavItemExternalLink>,
  );
  menuItems.push(
    <NavItemInternalLink
      to="/mitarbeiter/rotationsplaene"
      onClick={() => {
        setActiveSubmenu('mitarbeiter');
        handleClose();
      }}>
      {t('domain.navigation.menuItems.mitarbeiter.rotationsplan')}
    </NavItemInternalLink>,
  );

  return menuItems;
}
